import { ApolloLink } from '@apollo/client'
import { from, mergeMap, of } from 'rxjs'

import {
  ALLOW_LOGGED_OUT_AUTH_REJECTION_CONTEXT_KEY,
  isOnPublicPublishPage,
} from './authRejection'
import { checkAuthDoor } from './oidcAuth/checkAuthDoor'

export const PublicSessionLink = new ApolloLink((operation, forward) => {
  if (
    operation.operationName !== 'GetPublicSession' ||
    !isOnPublicPublishPage() ||
    operation.getContext()[ALLOW_LOGGED_OUT_AUTH_REJECTION_CONTEXT_KEY] !== true
  ) {
    return forward(operation)
  }

  return from(checkAuthDoor()).pipe(
    mergeMap((hasSessionCookies) =>
      hasSessionCookies === false
        ? of({ data: { account: null } })
        : forward(operation),
    ),
  )
})
